import { mapActions, mapGetters, mapMutations } from "vuex";
import { camelCase } from "lodash";
import Item from "../../components/material-item/index.vue";
import BtnLoadMore from "@/components/atoms/buttons/load-more/index.vue";
import { seo } from "@/mixins/seo";

export default {
	name		: "course-materials",
	mixins		: [seo],
	components	: {
		Item,
		BtnLoadMore,
	},
	created() {
		if (!this.list.length) {
			this.fetchData({ isNotFirstLoad: false, ...this.$route.params }).then(() => {
				this.seo.title = this.$t(camelCase(this.$route.params.materialType));
				
				this.$emit("updateHead");
			});
		}
		
		this.getComponents({ slug: this.$route.params.item });
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (
				from.name !== "course-materials" &&
				from.name !== "course-material-detail"
			) {
				vm.setList([]);
				vm.fetchData({
					isNotFirstLoad: false,
					...vm.$router.currentRoute.params,
				});
			}
		});
	},
	beforeRouteUpdate(to, from, next) {
		setTimeout(() => {
			this.fetchData({ isNotFirstLoad: false, ...this.$route.params }).then(() => {
				this.seo.title = this.$t(camelCase(this.$route.params.materialType));
				
				this.$emit("updateHead");
			});
		}, 10);
		
		next();
	},
	computed	: {
		...mapGetters({
			list: "coursesMaterials/list",
			listLength: "coursesMaterials/listLength",
			isListLoading: "coursesMaterials/isListLoading",
		}),
	},
	methods		: {
		...mapActions({
			fetchData: "coursesMaterials/FETCH_MATERIALS",
			getComponents: "courses/GET_COMPONENTS",
		}),
		...mapMutations({
			setList: "coursesMaterials/MATERIALS_SET_LIST",
		}),
		loadMore() {
			this.fetchData({ isNotFirstLoad: true, ...this.$route.params });
		},
		formattedTitle(title) {
			return camelCase(title);
		},
	},
};
